module.exports = __webpack_public_path__ + "img/icwithdraw.b91332ea.png";